$(function() {
  initBrandFilter();
});

function initBrandFilter() {
  // Filter using navigation
  $(".brand-nav-item a").click(function() {
    var nav = $(this).attr("data-nav");


    // Remove & Add active class
    $(".brand-nav-item").removeClass("active");
    $(this)
      .parent()
      .toggleClass("active");

    // Hide all the results
    $(".brand-results-row").addClass("inactive");


    // Loop through the row
    $(".brand-results-row").each(function() {
      var term = $(this).attr("data-term");

      if (nav == term) {
        $(this).removeClass("inactive");
      }
    });

    // Only return false if data-toggle is brand
    if ($(this).attr("data-toggle") == "brand") {
      return false;
    }
  
    });
}


    
   $('.mobile-sub-collection').flickity({
      freeScroll: true,
      imagesLoaded: true,
      contain: true,
      wrapAround: false,
      draggable: true,
      cellAlign: 'left',
      watchCSS: false,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false
    });

jQuery(function($){
   
    $('.main-carousel').flickity({
  		// options
  		wrapAround: true,
      pageDots: false,
      initialIndex: 1,
      fade: true,
      watchCSS: true,
      prevNextButtons: false,
      accessibility: true, //true by default
      autoPlay: true // advance cells every 3 seconds
    });
  });

$('.message-header').flickity({
  // options
    cellAlign: 'center',
    contain: false,
    initialIndex: 1,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    imagesLoaded: false,
    fade: true,
    autoPlay: 5000
});

/* Complete the look */
/*$('.complete_the_look__slider').flickity({
  // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: true,
    pageDots: true,
    draggable: true,
    imagesLoaded: false,
    fade: true,
    autoPlay: false
});*/


jQuery(function($){
  
  $( "#cnc-results-container" ).hide();

$("#cnc-container").on('click', function() {
  
  //console.log("Event clicked");
  $( "#cnc-results-container" ).toggle();
});
  
});

/* THF Custom code */
$( ".add_to_cart" ).click(function() {    

 var countTime_addtocart = 0;
 var refreshIntervalId_addtocart = setInterval(function(){
      ++countTime_addtocart;
         if(countTime_addtocart == 12){
           clearInterval(refreshIntervalId_addtocart);

     
      }
        $(".ProPriceMini").load(window.location.href + " .ProPriceMini" );
   }, 1000);
  
});



$( ".remove-icon" ).click(function() {    
 var countTime_removeicon = 0;
  
 var refreshIntervalId_removeicon = setInterval(function(){
      ++countTime_removeicon;
         if(countTime_removeicon == 12){
           clearInterval(refreshIntervalId_removeicon);

     
      }
        $(".ProPriceMini").load(window.location.href + " .ProPriceMini" );
   }, 1000);
});
         
$( ".js-change-quantity" ).click(function() {    
var countTime_quantity = 0;
 var refreshIntervalId_quantity = setInterval(function(){
      ++countTime_quantity;
         if(countTime_quantity == 12){
           clearInterval(refreshIntervalId_quantity);

     
      }
        $(".ProPriceMini").load(window.location.href + " .ProPriceMini" );
   }, 1000);
}); 
